/**
 * Styled Components - Created by cazarez on 20/02/18.
 */
import styled from 'styled-components'
import Modal from 'antd/lib/modal'

export const Container = styled.div`
  display: flex;
  justify-content: center;
`

export const StyledModal = styled(Modal)`
  &.p-0 .modal-close-icon,
  &.rounded-sm .modal-close-icon {
    top: 20px;
  }

  &.start-design-modal .modal-close-icon {
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    max-width: 32px;
    padding: 6px;
    box-sizing: border-box;
    z-index: 2;
  }

  &.p-0 .ant-modal-body {
    padding-bottom: 0px !important;
  }

  &.rounded-sm .ant-modal-content {
    border-radius: 16px !important;
  }

  &.image-cropper-modal .ant-modal-content {
    overflow: hidden;
  }

  &.image-cropper-modal .ant-modal-body {
    padding: 0 !important;
  }

  &[data-appearance='v2'] {
    .ant-modal-content {
      border-radius: 0;
      border: var(--border-regular) solid var(--neutral-border-light);
      box-shadow: 0 16px 16px rgba(10, 10, 9, 0.08);
    }
    .ant-modal-body {
      padding: var(--spacing-32) var(--spacing-24);
    }
    .modal-close-icon {
      top: var(--spacing-32);
      right: var(--spacing-24);
      width: 24px;
      height: 24px;
      max-width: 24px;
    }
  }

  &.contact-modal-v2,
  &.passcode-modal-v2,
  &.share-modal-v2 {
    .ant-modal-body {
      padding: var(--spacing-32);
    }
    .modal-close-icon {
      top: calc(var(--spacing-32) + (50px - 24px) / 2);
      right: var(--spacing-32);
    }
  }

  &.contact-modal-v2 {
    @media (min-width: 768px) {
      width: 492px !important;
    }
  }

  &.personalization-guidelines-modal {
    &[data-appearance='v2'] {
      .ant-modal-content {
        box-shadow: 0 16px 16px rgba(10, 10, 9, 0.08);
      }
      .ant-modal-body {
        padding: 0;
      }
      .modal-close-icon {
        top: var(--spacing-32);
        right: var(--spacing-32);
      }
    }
    @media (max-width: 767px) {
      width: calc(100vw - 40px) !important;
      max-width: 100%;
      &[data-appearance='v2'] .ant-modal-content {
        box-shadow: 0 12px 12px rgba(10, 10, 9, 0.1);
      }
      &[data-appearance='v2'] .modal-close-icon {
        top: var(--spacing-24);
        right: 20px;
        width: 18px;
        height: 18px;
        max-width: 18px;
      }
    }
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: center;
`

export const CloseIcon = styled.img`
  position: absolute;
  right: 20px;
  max-width: 18px;
  &:hover {
    cursor: pointer;
  }
`

export const Logo = styled.img`
  margin-top: -25px;
  margin-bottom: 30px;
`

export const Title = styled.div`
  margin-bottom: 20px;
  color: #5f6062;
  font-size: 20px;
  font-weight: bold;
  line-height: 27px;
  @media (max-width: 425px) {
    font-size: 14px;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/Common/JakrooModal/styledComponents.tsx